module.exports = __webpack_public_path__ + "officialStatic/img/plus-icon4.7c786fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/plus-icon4.png
// module id = NDTs
// module chunks = 0